import ImageTransition from './image-transition';

export default class ImageTransitionDesktop extends ImageTransition {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/image-transition/image-transition.desktop.js